import EntityBase from '@/data/EntityBase';

import { immerable } from 'immer';

// @ts-ignore
export default class EntityState<EntityType = unknown> extends EntityBase<EntityType, unknown>({}) {
  [immerable] = true;
}
